import React, { useState, useRef, useCallback, useEffect, useContext } from 'react';
import { hostedFields, client, paypalCheckout } from 'braintree-web';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var defaultState = {
    addField: function (_a) { },
    getPayload: function () { return null; },
    reset: function () { return null; },
    paypalPayload: null,
    paypalReady: false,
};
var DropinContext = React.createContext(defaultState);
var DropinProvider = function (_a) {
    var children = _a.children, authorization = _a.authorization, styles = _a.styles, withPaypal = _a.withPaypal, paypalStyles = _a.paypalStyles;
    var _b = useState({
        cvv: {},
        number: {},
    }), fields = _b[0], setFields = _b[1];
    var _c = useState({}), events = _c[0], setEvents = _c[1];
    var _d = useState(null), client$1 = _d[0], setClient = _d[1];
    var _e = useState(null), paypalPayload = _e[0], setPaypalPayload = _e[1];
    var _f = useState(false), paypalReady = _f[0], setPaypalReady = _f[1];
    var hostedFieldsInstance = useRef(null);
    var paypalInstance = useRef(null);
    var initHostedFields = useCallback(function () {
        if (client$1) {
            hostedFields
                .create({
                client: client$1,
                styles: styles,
                fields: fields,
            })
                .then(function (instance) {
                var _a, _b, _c, _d, _e, _f, _g;
                hostedFieldsInstance.current = instance;
                function handler(e, kind) {
                    if (events[e.emittedBy][kind]) {
                        return events[e.emittedBy][kind](e);
                    }
                }
                var onFocus = function (e) { return handler(e, 'onFocus'); };
                var onBlur = function (e) { return handler(e, 'onBlur'); };
                var onEmpty = function (e) { return handler(e, 'onEmpty'); };
                var onNonEmpty = function (e) { return handler(e, 'onNonEmpty'); };
                var onCardTypeChange = function (e) { return handler(e, 'onCardTypeChange'); };
                var onValidityChange = function (e) { return handler(e, 'onValidityChange'); };
                var onInputSubmitRequest = function (e) {
                    return handler(e, 'onInputSubmitRequest');
                };
                (_a = hostedFieldsInstance.current) === null || _a === void 0 ? void 0 : _a.on('focus', onFocus);
                (_b = hostedFieldsInstance.current) === null || _b === void 0 ? void 0 : _b.on('blur', onBlur);
                (_c = hostedFieldsInstance.current) === null || _c === void 0 ? void 0 : _c.on('empty', onEmpty);
                (_d = hostedFieldsInstance.current) === null || _d === void 0 ? void 0 : _d.on('notEmpty', onNonEmpty);
                (_e = hostedFieldsInstance.current) === null || _e === void 0 ? void 0 : _e.on('cardTypeChange', onCardTypeChange);
                (_f = hostedFieldsInstance.current) === null || _f === void 0 ? void 0 : _f.on('validityChange', onValidityChange);
                (_g = hostedFieldsInstance.current) === null || _g === void 0 ? void 0 : _g.on('inputSubmitRequest', onInputSubmitRequest);
            });
        }
    }, [client$1, styles, fields]);
    var initPaypal = useCallback(function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, btn, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        if (!(client$1 && withPaypal)) return [3 /*break*/, 5];
                        _a = paypalInstance;
                        return [4 /*yield*/, paypalCheckout.create({
                                client: client$1,
                            })];
                    case 1:
                        _a.current = _b.sent();
                        return [4 /*yield*/, paypalInstance.current.loadPayPalSDK({
                                vault: true,
                                intent: 'tokenize',
                            })
                            // @ts-ignore
                        ];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, paypal.Buttons({
                                style: paypalStyles,
                                // @ts-ignore
                                fundingSource: paypal.FUNDING.PAYPAL,
                                createBillingAgreement: function () {
                                    var _a;
                                    return (_a = paypalInstance.current) === null || _a === void 0 ? void 0 : _a.createPayment({
                                        // @ts-ignore
                                        flow: 'vault',
                                        // @ts-ignore
                                        intent: 'tokenize',
                                    });
                                },
                                onApprove: function (data) {
                                    var _a;
                                    return (_a = paypalInstance.current) === null || _a === void 0 ? void 0 : _a.tokenizePayment(data, function (err, payload) {
                                        if (!err)
                                            setPaypalPayload(payload);
                                    });
                                },
                                onCancel: function (data) {
                                    console.log('PayPal payment cancelled', JSON.stringify(data, null, 2));
                                },
                                onError: function (err) {
                                    console.error('PayPal error', err);
                                },
                            })];
                    case 3:
                        btn = _b.sent();
                        return [4 /*yield*/, btn.render('#braintreeact-paypal-button')];
                    case 4:
                        _b.sent();
                        setPaypalReady(true);
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _b.sent();
                        console.error('PayPal mounting error', err_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }, [client$1, withPaypal, paypalStyles]);
    useEffect(function () {
        if (!client$1) {
            client.create({ authorization: authorization }).then(setClient);
        }
    }, []);
    useEffect(function () {
        if (!hostedFieldsInstance.current) {
            initHostedFields();
        }
        return function () {
            if (hostedFieldsInstance.current) {
                hostedFieldsInstance.current.teardown();
                hostedFieldsInstance.current = null;
            }
        };
    }, [initHostedFields]);
    useEffect(function () {
        initPaypal();
        return function () {
            var _a;
            (_a = paypalInstance.current) === null || _a === void 0 ? void 0 : _a.teardown();
            paypalInstance.current = null;
        };
    }, [initPaypal]);
    function addField(options) {
        var type = options.type, onBlur = options.onBlur, onFocus = options.onFocus, onEmpty = options.onEmpty, onNonEmpty = options.onNonEmpty, onCardTypeChange = options.onCardTypeChange, onValidityChange = options.onValidityChange, onInputSubmitRequest = options.onInputSubmitRequest, attrs = __rest(options, ["type", "onBlur", "onFocus", "onEmpty", "onNonEmpty", "onCardTypeChange", "onValidityChange", "onInputSubmitRequest"]);
        setFields(function (fields) {
            var _a;
            return (__assign(__assign({}, fields), (_a = {}, _a[type] = attrs, _a)));
        });
        setEvents(function (events) {
            var _a;
            return (__assign(__assign({}, events), (_a = {}, _a[type] = {
                onBlur: onBlur,
                onFocus: onFocus,
                onEmpty: onEmpty,
                onNonEmpty: onNonEmpty,
                onCardTypeChange: onCardTypeChange,
                onValidityChange: onValidityChange,
                onInputSubmitRequest: onInputSubmitRequest,
            }, _a)));
        });
    }
    function getPayload() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var fields_1, invalidFields, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        if (!paypalPayload) return [3 /*break*/, 1];
                        return [2 /*return*/, paypalPayload];
                    case 1:
                        fields_1 = ((_a = hostedFieldsInstance.current) === null || _a === void 0 ? void 0 : _a.getState()).fields;
                        invalidFields = Object.keys(fields_1).filter(function (field) { return !fields_1[field].isValid; });
                        if (!(invalidFields.length === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, ((_b = hostedFieldsInstance.current) === null || _b === void 0 ? void 0 : _b.tokenize())];
                    case 2: return [2 /*return*/, _c.sent()];
                    case 3: return [2 /*return*/, Promise.reject(invalidFields)];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_2 = _c.sent();
                        return [2 /*return*/, Promise.reject(err_2)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function reset() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = hostedFieldsInstance.current) === null || _a === void 0 ? void 0 : _a.teardown();
                        return [4 /*yield*/, ((_b = paypalInstance.current) === null || _b === void 0 ? void 0 : _b.teardown())];
                    case 1:
                        _c.sent();
                        setPaypalPayload(null);
                        hostedFieldsInstance.current = null;
                        paypalInstance.current = null;
                        initHostedFields();
                        initPaypal();
                        return [2 /*return*/];
                }
            });
        });
    }
    var value = { addField: addField, paypalPayload: paypalPayload, getPayload: getPayload, reset: reset, paypalReady: paypalReady };
    return (React.createElement(DropinContext.Provider, { value: value }, children));
};

var Dropin = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(DropinProvider, __assign({}, props), children);
};

var Field = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, props = __rest(_a, ["children", "className", "style"]);
    var ref = useRef();
    var addField = useContext(DropinContext).addField;
    useEffect(function () {
        addField(__assign({ container: ref.current }, props));
    }, []);
    return (React.createElement(React.Fragment, null,
        children && typeof children === 'function' ? children('hola') : null,
        React.createElement("div", { ref: ref, className: className, style: style })));
};

var PaypalButton = function (_a) {
    return React.createElement("div", { id: "braintreeact-paypal-button" });
};

export { Dropin, DropinContext, Field, PaypalButton };
